export default "/images/fea83bce66ef24905546847f4b491567.avif";